import axios from 'axios';

function normalizeBackendOrigin(raw) {
  if (raw == null) return '';
  const s = String(raw).trim().replace(/\/$/, '');
  if (!s || s === 'undefined' || s === 'null') return '';
  return s;
}

/**
 * API root (…/api). Ordning:
 * 1. window.__BYGGFYND_API_ORIGIN__ (kan sättas i index.html utan ombyggnad)
 * 2. REACT_APP_BACKEND_URL (byggtid)
 * 3. Utveckling: localhost:8000
 * 4. Produktion: samma origin som sidan
 */
function computeApiBase() {
  if (typeof window !== 'undefined') {
    const w = normalizeBackendOrigin(window.__BYGGFYND_API_ORIGIN__);
    if (w) return `${w}/api`;
  }

  const fromEnv = normalizeBackendOrigin(process.env.REACT_APP_BACKEND_URL);

  if (process.env.NODE_ENV === 'development') {
    const origin = fromEnv || 'http://127.0.0.1:8000';
    return `${origin}/api`;
  }

  if (fromEnv) {
    return `${fromEnv}/api`;
  }

  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}/api`;
  }

  return '/api';
}

const apiClient = axios.create();

apiClient.interceptors.request.use((config) => {
  config.baseURL = computeApiBase();
  const token = localStorage.getItem('byggfynd_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const isAuthRoute = error.config?.url?.includes('/auth/');
      if (!isAuthRoute) {
        localStorage.removeItem('byggfynd_token');
        window.dispatchEvent(new Event('auth:logout'));
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
